// Render-time Cloudinary transforms. We store the raw secure_url; this inserts
// f_auto,q_auto and a width into the delivery URL so phones don't download
// full-resolution originals. Non-Cloudinary URLs pass through untouched.

const UPLOAD_MARKER = "/image/upload/";

export function cldImg(url, width = 800) {
    if (!url || typeof url !== "string") return url || "";
    if (!url.includes("res.cloudinary.com")) return url;
    const i = url.indexOf(UPLOAD_MARKER);
    if (i === -1) return url;
    const head = url.slice(0, i + UPLOAD_MARKER.length);
    const tail = url.slice(i + UPLOAD_MARKER.length);
    if (/^(f_auto|q_auto|w_\d)/.test(tail)) return url; // already transformed
    return `${head}f_auto,q_auto,w_${width}/${tail}`;
}
